import React, { useCallback, useEffect, useState } from "react";
import { Button, Empty, message, Popconfirm, Select, Tag, Tooltip } from "antd";
import { ModalBody, ModalWrapper } from "./SelectPeoplePopupStyled";
import { inject, observer } from "mobx-react";
import SelectUserDepartmentBox from "./SelectUserDepartmentBox";
import { ASSIGNEE_TYPE } from "../../constants";
import { AvatarHasName } from "../common/Avatar";
import {
  BankOutlined,
  CloseOutlined,
  WarningOutlined,
} from "@ant-design/icons";
// import SpinnerInlineComponent from '../SpinnerInlineComponent/SpinnerInlineComponent'
import "./SelectPeaoplePopup.scss";

const SelectPeoplePopup = (props) => {
  const {
    placeholder,
    isVisibleSelectPeoplePopup,
    handleSubmitSelectUser,
    handleCancelSelectUser,
    selectPeopleStore,
    // loadingAnimationStore,
    authenticationStore,
    companyStore,
    onlyOneUser,
    onlySelectOne,
    disableSelectDepartment,
    noLoadSelectData,
    title,
    okText,
    cancelText,
    isOpenCollapse,
    allowChangeCompany,
    handleUpdateEmpty = () => {},
    isUserDisableList = true,
  } = props;
  const {
    selectPopupName,
    companyCode,
    assigneePopupType,
    selectUserData,
    setSelectUserData,
    selectDepartmentData,
    setSelectDepartmentData,
    setDepartmentWithUserList,
    originDepartmentWithUserList,
    handleCancelSelectUserDepartment,
  } = selectPeopleStore;

  const [selectedList, setSelectedList] = useState([]);
  const [userDisableList, setUserDisableList] = useState([]);
  const [departmentDisableList, setDepartmentDisableList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [prevUserList, setPrevUserList] = useState([]);
  const [prevDepartmentList, setPrevDepartmentList] = useState([]);

  const { getCompanyList, companyList } = companyStore;
  const showDropdownCompany = allowChangeCompany ?? true;

  useEffect(() => {
    getCompanyList();
    if (!assigneePopupType) return;
    setPrevUserList(selectUserData[assigneePopupType]);
    setPrevDepartmentList(selectDepartmentData[assigneePopupType]);
  }, [isVisibleSelectPeoplePopup]);

  useEffect(() => {
    if (noLoadSelectData) return;
    (async () => {
      if (companyCode) {
        try {
          setIsLoading(true);
          await selectPeopleStore.getDepartmentWithUsers();
        } catch (err) {
          console.log(err);
          message.error(err.vi || "Đã có lỗi xảy ra!");
        } finally {
          setIsLoading(false);
        }
      }
    })();
  }, [companyCode]);

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode();
    }
  }, [authenticationStore.currentUser]);
  useEffect(() => {
    if (!assigneePopupType) return;
    const selectedUserList = [
      ...selectUserData[ASSIGNEE_TYPE.LEADER],
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectUserData[ASSIGNEE_TYPE.SIGNER],
      ...(selectUserData[ASSIGNEE_TYPE.UNIT_LEADER] || []),
      ...(selectUserData[ASSIGNEE_TYPE.KT_KTNB] || []),
      ...(selectUserData[ASSIGNEE_TYPE.HDQT] || []),
      ...(selectUserData[ASSIGNEE_TYPE.lanh_dao_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_kt_ktnb] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.CREATE]
        ? selectUserData[ASSIGNEE_TYPE.CREATE]
        : []),
    ];

    const selectedDepartmentList = [
      ...selectDepartmentData[ASSIGNEE_TYPE.LEADER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...(selectDepartmentData[ASSIGNEE_TYPE.UNIT_LEADER] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.KT_KTNB] || []),
      ...(selectDepartmentData[ASSIGNEE_TYPE.HDQT] || []),
      ...(selectUserData[ASSIGNEE_TYPE.lanh_dao_vimc] || []),
      ...(selectUserData[ASSIGNEE_TYPE.CREATE]
        ? selectDepartmentData[ASSIGNEE_TYPE.CREATE]
        : []),
    ];
    isUserDisableList &&
      setUserDisableList(
        selectedUserList
          .filter(
            (el) =>
              el.permission !== assigneePopupType &&
              el.permission !== ASSIGNEE_TYPE.lanh_dao_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_kt_ktnb &&
              el.permission !== ASSIGNEE_TYPE.ban_pc_qtrr_ban_kt_ktnb_vimc &&
              el.permission !== ASSIGNEE_TYPE.ban_dieu_hanh_hdqt_vimc
          )
          .map((el) => el.id)
      );
    setDepartmentDisableList(
      selectedDepartmentList
        .filter((el) => el.permission !== assigneePopupType)
        .map((el) => el.id)
    );
  }, [assigneePopupType]);

  useEffect(() => {
    if (!assigneePopupType) return;
    setSelectedList([
      ...selectUserData[assigneePopupType],
      ...selectDepartmentData[assigneePopupType],
    ]);
  }, [selectUserData, selectDepartmentData, assigneePopupType]);

  const handleRemoveSelect = useCallback(
    (item) => {
      if (!assigneePopupType) return;
      setSelectUserData({
        ...selectUserData,
        [assigneePopupType]: selectUserData[assigneePopupType].filter(
          (el) => el.id !== item.id
        ),
      });
      setSelectDepartmentData({
        ...selectDepartmentData,
        [assigneePopupType]: selectDepartmentData[assigneePopupType].filter(
          (el) => el.id !== item.id
        ),
      });
    },
    [assigneePopupType, selectUserData, selectDepartmentData]
  );

  useEffect(() => {
    setDepartmentWithUserList(originDepartmentWithUserList);
  }, [isVisibleSelectPeoplePopup]);

  const handleSelectChange = (e) => {
    selectPeopleStore.companyCode = e.target.value;
  };

  return (
    <ModalWrapper
      maskClosable={false}
      okText={okText || "Đồng ý"}
      cancelText={"Hủy bỏ"}
      width={800}
      style={{ top: 20 }}
      zIndex={99999}
      title={
        <div
          style={{
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              margin: "10px 0",
              gap: 8,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {disableSelectDepartment || cancelText ? (
              // <Popconfirm
              //   placement="top"
              //   title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              //   onConfirm={async () => {
              //     selectPeopleStore.setSelectUserData({
              //       ...selectUserData,
              //       [assigneePopupType]: [],
              //     })
              //     handleUpdateEmpty()
              //     // handleCancelSelectUser()
              //   }}
              //   okText="Đồng ý"
              //   cancelText="Không"
              //   zIndex={100000}>
              <Button
                danger
                icon={
                  <WarningOutlined
                    style={{ color: "#fa8c16", verticalAlign: "middle" }}
                  />
                }
                onClick={() => {
                  selectPeopleStore.setSelectUserData({
                    ...selectUserData,
                    [assigneePopupType]: [],
                  });
                  handleUpdateEmpty();
                }}
                style={{ display: "flex", alignItems: "center" }}
              >
                {cancelText || "Hủy chọn"}
              </Button>
            ) : (
              // </Popconfirm>
              // <Popconfirm
              //   zIndex={100000}
              //   placement="top"
              //   title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              //   onConfirm={() => {
              //     selectPeopleStore.handleRemoveSelectUserDepartment()
              //   }}
              //   okText="Đồng ý"
              //   cancelText="Không">
              <Button
                danger
                style={{ display: "flex", alignItems: "center" }}
                icon={<WarningOutlined style={{ color: "#3fa8c16" }} />}
                onClick={() => {
                  selectPeopleStore.handleRemoveSelectUserDepartment();
                }}
              >
                {cancelText || "Hủy chọn"}
              </Button>
              // </Popconfirm>
            )}
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Button
                style={{
                  backgroundColor: " #1677ff",
                  color: "#fff",
                  boxShadow: " 0 2px 0 rgba(5, 145, 255, 0.1)",
                }}
                onClick={() => {
                  JSON.stringify(selectDepartmentData[assigneePopupType]) !==
                    JSON.stringify(prevDepartmentList) ||
                  JSON.stringify(selectUserData[assigneePopupType]) !==
                    JSON.stringify(prevUserList)
                    ? handleSubmitSelectUser()
                    : handleCancelSelectUser();
                }}
              >
                {okText || "Đồng ý"}
              </Button>
              {!cancelText && (
                <div>
                  {/* {disableSelectDepartment ? (
                  <Tooltip title={'Đóng'}>
                    <CloseOutlined onClick={handleCancelSelectUser} />
                  </Tooltip>
                ) : ( */}
                  <Tooltip title={"Đóng"}>
                    <Button
                      style={{
                        display: "flex",
                        backgroundColor: "red",
                        color: "#fff",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        setSelectUserData({
                          ...selectUserData,
                          [assigneePopupType]: prevUserList,
                        });
                        setSelectDepartmentData({
                          ...selectDepartmentData,
                          [assigneePopupType]: prevDepartmentList,
                        });
                        handleCancelSelectUserDepartment();
                        handleCancelSelectUser();
                      }}
                    >
                      <CloseOutlined />
                    </Button>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
          {showDropdownCompany ? (
            <select
              style={{
                color: companyCode === "" ? "rgb(161 169 179)" : "black",
                width: "100%",
                WebkitAppearance: "none",
                padding: "5px",
                outline: "none",
                borderRadius: "5px",
                border: "1.5px solid #d9d9d9",
                overflow: "hidden",
                fontSize: 10,
              }}
              onChange={handleSelectChange}
              value={companyCode}
              placeholder={"-- Chọn công ty --"}
            >
              {companyList.map((item) => (
                <option
                  style={{ width: "100px", wordWrap: "break-word" }}
                  key={item.code}
                  value={item.code}
                >
                  <span>{item.name}</span>
                </option>
              ))}
            </select>
          ) : (
            <span>{title || selectPopupName}</span>
          )}
        </div>
      }
      closable={false}
      forceRender={true}
      footer={null}
      open={isVisibleSelectPeoplePopup}
    >
      <ModalBody>
        <div
          style={{
            gap: 4,
            paddingTop: 10,
            margin: "2px",
          }}
        >
          <div
            className={"selected-list"}
            style={{
              flex: "0 0 720px",
              maxHeight: "calc(100vh - 111px)",
              overflowY: "auto",
              maxWidth: 720,
              backgroundColor: "#fff",
              margin: "-10px 0 -15px 0",
              borderLeft: "1px solid #f0f0f0",
              padding: "15px 10px",
            }}
          >
            <div
              style={{
                margin: "-15px -10px 10px -10px",
                padding: 15,
                borderBottom: "1px solid #f0f0f0",
                fontWeight: 500,
                backgroundColor: "#e9f7ff",
              }}
            >
              Danh sách đã chọn:
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                marginBottom: 10,
              }}
            >
              {selectedList.length > 0 ? (
                selectedList.map((el) => {
                  return (
                    <Tag
                      className={"tag-selected"}
                      color={"blue"}
                      key={el.id}
                      closable
                      onClose={() => handleRemoveSelect(el)}
                    >
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )
                        }
                      />
                    </Tag>
                  );
                })
              ) : (
                <Empty
                  style={{ width: "100%" }}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
              )}
            </div>
          </div>
          <div style={{ flexGrow: 1 }}>
            <div className={"modal-body"} style={{ position: "relative" }}>
              <SelectUserDepartmentBox
                placeholder={placeholder}
                isOpenCollapse={isOpenCollapse}
                isVisibleSelectPeoplePopup={isVisibleSelectPeoplePopup}
                disableSelectDepartment={disableSelectDepartment}
                onlyOneUser={onlyOneUser}
                onlySelectOne={onlySelectOne}
                userDisableList={userDisableList}
                departmentDisableList={departmentDisableList}
              />
              {/* <SpinnerInlineComponent
                sizeSpin={'small'}
                isLoading={isLoading}
                noBackground
              /> */}
            </div>
          </div>
        </div>
      </ModalBody>
    </ModalWrapper>
  );
};

SelectPeoplePopup.propTypes = {};

export default inject(
  "selectPeopleStore",
  // 'loadingAnimationStore',
  "companyStore",
  "authenticationStore"
)(observer(SelectPeoplePopup));
